export function passwordValidator(password) {
    if (!password) return "A jelszó megadása kötelező."
    if (password.length < 6) return 'A jelszónak legalább 6 karakter hosszúnak kell lennie.'
  return ''
}
